import { render } from "./confirm-unsubscribe-from-pack.vue?vue&type=template&id=6b0b63bd&lang=pug"
import script from "./confirm-unsubscribe-from-pack.vue?vue&type=script&lang=js"
export * from "./confirm-unsubscribe-from-pack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__